import request from "superagent";
import APP_ENV from "../Environment";
import {Auth} from "aws-amplify";
import axiosBase from "axios";

export const oidcUserlogout = () =>{
    return new Promise((resolve, reject) => {
        request
            .get(`${APP_ENV.USERPOOLDOMEIN}/logout`)
            .withCredentials()
            .query({ client_id: APP_ENV.USERPOOLWEBCLIENTID })
            .query({ logout_uri: APP_ENV.USERPOOLDOMEIN })
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(true);
                return
            });

    });
};

const postOauth = (id_token, cognito_user_attributes, customer_id = null) => {
    return new Promise((resolve, reject) => {
        request
            .post(APP_ENV.BFF + '/oauth')
            .send({cognito_user_attributes, customer_id, sender: 'Change'})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${id_token}`)
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({status: 200});
            });
    });
};

const prepareOauth = (token_res) => {
    return new Promise((resolve, reject) => {
        request
            .post(APP_ENV.BFF + '/oauth/prepare')
            .send({access_token: token_res.access_token})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token_res.id_token}`)
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({status: 200, cognito_user_attributes: res.body.cognito_attributes});
            });
    });

};

const checkCodeFormat = (query_code) => {
    return new Promise((resolve, reject) => {
        query_code ? resolve(query_code) : reject("oauth認証エラー")
    })
};

const postToken = (code, access_url) => {
    return new Promise(((resolve, reject) => {
        request
            .post(`${APP_ENV.USERPOOLDOMEIN}/oauth2/token`)
            .set('Authorization', `Basic ${process.env.REACT_APP_OIDC_SIGN_UP_POOL_KEY}`)
            .type('form')
            .send({
                grant_type: 'authorization_code',
                client_id: APP_ENV.USERPOOLWEBCLIENTID_FOR_OIDCSIGNUP,
                redirect_uri: `${APP_ENV.FRONT_URL}/${access_url}`,
                code
            })
            .end((err, res) => {
                if (err) {
                    window.history.replaceState('','','/');
                    reject(err);
                }
                resolve(res.body);
            });

    }))
};

const fetchOIDCInfo = async (query_code) => {
    try {
        const code = await checkCodeFormat(query_code);
        const token_res = await postToken(code, 'prepare_oauth');
        const res = await prepareOauth(token_res);
        window.history.replaceState('','','/sign_up');
        return res;

    } catch (e) {
        throw e;
    }

};

export const connectOIDCInfo = async (query_code) => {
    try {
        const user = await Auth.currentAuthenticatedUser();
        const code = await checkCodeFormat(query_code);
        const token_res = await postToken(code, 'connect_oauth');
        const prepare_oauth_res = await prepareOauth(token_res);
        const id_token = user.signInUserSession.idToken.jwtToken;
        const res = await postOauth(id_token, prepare_oauth_res.cognito_user_attributes);
        oidcUserlogout().then(()=>console.log("success")).catch(()=>console.log("failure"));
        return res;

    } catch (e) {
        // amplifのライブラリでuser情報が取得できなかった場合(oidcログインで遷移してきた場合)
        try {
            const axios = axiosBase.create({
                baseURL: APP_ENV.BFF,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("token_res")}`
                },
                responseType: 'json'
            });
            let oauth_get_res = await axios.get(APP_ENV.BFF + "/oauth")
            let user = oauth_get_res.data;

            const code = await checkCodeFormat(query_code);
            const token_res = await postToken(code, 'connect_oauth');
            const prepare_oauth_res = await prepareOauth(token_res);
            const res = await postOauth(token_res.id_token, prepare_oauth_res.cognito_user_attributes,user['custom:ecc_customer_id']);
            oidcUserlogout().then(()=>console.log("success")).catch(()=>console.log("failure"));
            return res;

        } catch (err) {
            throw e;
        }
    }

};

export default fetchOIDCInfo;